import React from 'react';
import questions from '../../survey/questions';
import steps from '../../survey/steps';

function DefaultOption (props) {
	function checkIfOptionSelected () {
		const check = questions.isAnswerSelected({
			questionName: props.questionName,
			answer: props.option.value
		});

		return check;
	}

	function toggleAnswer () {
		const resetAnswer = props.resetIfValueSelected && props.option.value === props.resetIfValueSelected && !questions.isAnswerSelected({ questionName: props.questionName, answer: props.option.value });
		const resetableAnswer = props.resetIfValueSelected;

		if (resetAnswer) {
			questions.addOnlyAnswer({
				questionName: props.questionName,
				answer: props.option
			});

			setTimeout(() => {
				steps.navigate.forward({
					preventAction: 500
				});
			}, 300);
		}

		if (resetableAnswer && props.option.value !== props.resetIfValueSelected) {
			questions.removeAnswer({
				questionName: props.questionName,
				answer: { value: props.resetIfValueSelected }
			});
		}

		!resetAnswer && questions.toggleAnswer({
			questionName: props.questionName,
			answer: props.option
		});
	}

	return (
		<button
			type="button"
			className={`${props.className} ${checkIfOptionSelected() ? (props.selectedStateClass) : ''}`}
			onClick={toggleAnswer}
			tabIndex={props.disableFromFocus ? -1 : ''}
		>
			{props.children}
		</button>
	);
}

export default DefaultOption;
